import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentPlan, getRendersPlan } from '../../../Redux/actions/commonActtion';
import PaymentsDetails from "../UserPlan/PaymentsDetails";
import "../Render/RenderStyle.css";
import { ScrollX_250, ScrollX_limited } from "../../../assets/icons";

const AllPlansList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem("user"));
    const [currentPlanRange, setCurrentPlanRange] = useState({ start: 0, end: 2, });
    const [isOpen, setIsOpen] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState({});
    const [isSuccessOpen, setIsSuccessOpen] = useState(false);

    const { renderPlan } = useSelector(state => state.commonReducer)
    const state = useSelector((state) => state?.commonReducer.renderPlan);
    // console.log('state === ', state);
    const commonReducer = useSelector((state) => state?.commonReducer);
    const currentPlan = commonReducer?.currentPlan
    const currentPlanDetails = currentPlan?.plan?.plan_detail
    const [isUserPaid, setIsUserPaid] = useState(currentPlan.success && currentPlan.plan ? true : false);

    useEffect(() => {
        getRenderPlanDetails();
    }, []);

    const getRenderPlanDetails = async () => {
        await dispatch(getRendersPlan(user));
        await dispatch(getCurrentPlan());
    };

    const createdAt = new Date(currentPlan?.plan?.createdAt);
    const planPurchaseDate = isNaN(createdAt.valueOf()) ? "" : `${createdAt?.getDate()}/${createdAt?.getMonth() + 1}/${createdAt?.getFullYear()}`;

    const validityValue = parseInt(currentPlanDetails?.validity, 10) || 0
    const [remainingDays, setRemainingDays] = useState('')
    const [remainingHours, setRemainingHours] = useState(0)
    const [remainingMinutes, setRemainingMinutes] = useState(0)
    const [remainingSeconds, setRemainingSeconds] = useState(0)
    const today = new Date();
    const planRenewDate = new Date(createdAt?.getTime() + validityValue * 24 * 60 * 60 * 1000);
    let timeDifference = planRenewDate - today;

    useEffect(() => {
        let prevRemainingDays = remainingDays;

        if (remainingDays === 1 || validityValue === 1) {
            const interval = setInterval(() => getTime(prevRemainingDays), 1000);
            return () => clearInterval(interval);
        } else {
            getTime(prevRemainingDays);
        }
    }, [remainingDays, validityValue, timeDifference]);

    const getTime = async (prevRemainingDays) => {
        if (!isNaN(validityValue)) {
            if (timeDifference > 0) {

                if (timeDifference >= 24 * 60 * 60 * 1000) {
                    const updatedRemainingDays = Math.ceil(timeDifference / (24 * 60 * 60 * 1000));
                    timeDifference -= updatedRemainingDays * 24 * 60 * 60 * 1000;

                    if (prevRemainingDays === 1 && updatedRemainingDays === 0) {
                        setRemainingHours(0);
                        setRemainingMinutes(0);
                        setRemainingSeconds(0);
                        setIsUserPaid(false)
                    }
                    setRemainingDays(updatedRemainingDays);

                }
                if (timeDifference >= 60 * 60 * 1000) {
                    setRemainingHours(Math.floor(timeDifference / (60 * 60 * 1000)));
                    timeDifference -= (remainingHours * 60 * 60 * 1000)
                }

                if (timeDifference >= 60 * 1000) {
                    setRemainingMinutes(Math.floor(timeDifference / (60 * 1000)));
                    timeDifference -= (remainingMinutes * 60 * 1000)
                }

                setRemainingSeconds(Math.floor(timeDifference / 1000));
            } else if (remainingDays === 0) {
                setIsUserPaid(false)
                // console.log('prevRemainingDays', prevRemainingDays, "timeDifference", timeDifference, "remainingDays", remainingDays);  
            }
            else {
                setRemainingDays(0);
                setRemainingHours(0);
                setRemainingMinutes(0);
                setRemainingSeconds(0);
            }
        }
    };

    const expirationMessage = (remainingDays === 1 || validityValue === 1)
        ? `Plan Expires in ${remainingHours}:${remainingMinutes}:${remainingSeconds}`
        : (remainingDays > 1)
            ? `Remaining days ${remainingDays}`
            : Object.keys(currentPlan).length === 0 ? "Buy New Plan" : 'Plan Expired ';

    const goToNextPlan = () => {
        if (currentPlanRange.end < renderPlan.length - 1) {
            setCurrentPlanRange({
                start: currentPlanRange.start + 1,
                end: currentPlanRange.end + 1,
            });
        }
    };

    const goToPreviousPlan = () => {
        if (currentPlanRange.start > 0) {
            setCurrentPlanRange({
                start: currentPlanRange.start - 1,
                end: currentPlanRange.end - 1,
            });
        }
    };

    return (
        <>
            <div>

                <div className={`UpgradePlan-modelcontainer `}>
                    <div className="UpgradePlan-overlay" style={{ color: "#000", backgroundColor: '#1b1237'}}></div>

                    <div className="UpgradePlan-content">
                        <div className="w-full py-[4%]" style={{ display: "flex", flexDirection: "column", justifyContent: "space-evenly", alignItems: "center", }}>
                            <div className="w-full  pb-[4%]  flex justify-center items-center">
                                <div className="">
                                    <h3 className="text-2xl font-bold" style={{ fontFamily: "Avenir Book", color:'#fff' }}>Choose the plan that fits you best</h3>
                                    <p className="text-base FontFamily-Avenir-reg tracking-wide">Projects stay forever, but renders shine during your subscription.</p>
                                </div>
                                <div><span className="close-button" onClick={() => navigate('/dashboard')}>&#10005;</span></div>
                            </div>

                            <div className="flex justify-center items-center py-[2%] w-[85%]">
                                {renderPlan
                                    .slice(currentPlanRange.start, currentPlanRange.end + 1)
                                    .map((plan, ind) => (
                                        <div className={`page5paydiv2 cursor-pointer ${ind === 1 ? "active" : ""}`} key={`upg${ind + 1}`}
                                            onClick={() => {
                                                setSelectedPlan(plan);
                                                setIsOpen(true);
                                            }}                
                                        >
                                            <div className="relative">
                                                <img className={`imageScrollLimited ${ind === 1 ? "active" : ""}`}  src={ScrollX_limited} alt="" />                
                                            </div>

                                            <div className={`priceBlock1 w-full ${ind === 1 ? "active" : ""}`}>
                                            <img className={`image250 ${ind === 1 ? "active" : ""}`} src={ScrollX_250} alt="" />
                                            <h1 className="priceheading1" style={{fontFamily: "Avenir book", fontWeight: "bold", textDecoration: "none", color: "white",}}>
                                                {plan?.currency + plan?.price}
                                            </h1>
                                            <h3 className={`Syne700  priceheading3 ${ind === 1 ? "active" : ""}`} style={{fontWeight: "bold", textDecoration: "none", color: "white",}}>
                                                {plan?.type}
                                            </h3>
                                            <div className={`PricePlanbottom ${ind === 1 ? "active" : ""}`} style={{borderBottom: "1px solid #3a3755", width: "80%",}}/>
                                            <div className={` priceheading2 ${ind === 1 ? "active" : ""}`} 
                                                style={{fontFamily: "Avenir book", fontWeight: "normal", textDecoration: "none", color: "white",}}>
                                                {plan?.text1} <br /> {plan?.text2} <br /> <span className="font-bold">{plan?.validity}</span>
                                            </div>
                                            <div className={` priceheading4 pb-[1.5rem] ${ind === 1 ? "active" : ""}`}
                                                style={{fontFamily: "Avenir book", fontWeight: "normal", textDecoration: "none", color: "white",}}>
                                                {plan?.text3} <br /> {plan?.text4} <br /> Alpha Transparency
                                            </div>
                                            </div>
                                        
                                            {/* <div className="pt-2 ">
                                            <button className="font-bold text-xl" onClick={()=>navigate('/dashboard/pricingPlans/PaymentsDetails')}
                                                // onClick={() => { setSelectedPlan(plan); setIsOpen(true); }} 
                                                style={{ fontFamily: "Avenir book", backgroundColor: "#1c467d", borderRadius: "50px", color: "white",}}>Upgrade
                                            </button>
                                            </div> */}
                                            <div className={`priceLimitedtime ${ind === 1 ? "active" : ""}`}>**limited time 20% off</div>
                                        </div>
                                    )
                                )}
                            </div>

                            <button className="prev-button" onClick={goToPreviousPlan} disabled={currentPlanRange.start === 0}><span>&lt;</span></button>
                            <button className="next-button" onClick={goToNextPlan} disabled={currentPlanRange.end === renderPlan.length - 1}><span>&gt;</span></button>
                        </div>

                        {isOpen && (
                            <PaymentsDetails
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                selectedPlan={selectedPlan}
                                // IsUpgradeOpen={IsUpgradeOpen}
                                currentPlanDetails={currentPlanDetails}
                                remainingDays={remainingDays}
                                // setRenderOpen={setRenderOpen}
                                planPurchaseDate={planPurchaseDate}
                                expirationMessage={expirationMessage}
                                getTime={getTime}
                                setIsSuccessOpen={setIsSuccessOpen}
                                paymentType={currentPlan?.plan?.payment_type}
                                order_id={currentPlan?.plan?.order_id}
                                subscription_status={currentPlan?.plan?.subscription_status}
                            />
                        )}
                    </div>

                </div>

            </div>
        </>
    )
}

export default AllPlansList;